import BaseApiService from './BaseApiService';

class BreakApartApiService extends BaseApiService {
    constructor() {
        super('break-apart');
    }

    toServerObject(data) {
        return data
            .filter(datapoint => datapoint.drugBrandIds.length > 0)
            .map(datapoint => datapoint.drugBrandIds.map(drugBrandId => ({
                id: drugBrandId,
                year: datapoint.year,
                quarter: datapoint.quarter,
            })))
            .reduce((result, current) => result.concat(current), []);
    }

    async getAll({ rateData, companies, growthRatesQuarters, getFicBicData = false }) {
        const data = { drugs: rateData, companies: companies.join(','), growthRatesQuarters: growthRatesQuarters.join(','), getFicBicData };
        const response = await this.request({ method: 'post', url: '', data });

        return response || { revenues: [], events: [] };
    }

    async exportChartCsv({ rateData, companies, growthRatesQuarters }) {
        const data = { drugs: rateData, companies: companies.join(','), growthRatesQuarters: growthRatesQuarters.join(','), };
        const response = await this.request({ method: 'post', url: '', data }) .then(response => {
            this.forceFileDownload(response, name)

        })
            .catch(() => console.log('error occured'));
    }

    forceFileDownload(response, name){
        const url = window.URL.createObjectURL(new Blob([response]))
        const filename = (name) ? name+'.csv' : 'GrowthRate.csv';
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename) //or any other extension
        document.body.appendChild(link)
        link.click()
    }
}

export default new BreakApartApiService();
